import { formatDateTime, formatRelativeTime } from '../utils/dateUtils';

/**
 * Reusable component for displaying dates with relative time.
 * Shows both the formatted date/time and a relative time (e.g., "10 minutes ago").
 * 
 * @param {string} isoString - ISO date string to display
 * @param {object} style - Optional custom styles for the container
 */
function DateDisplay({ isoString, style = {} }) {
  if (!isoString) {
    return <span style={{ color: '#999' }}>N/A</span>;
  }

  return (
    <div style={style}>
      <div>{formatDateTime(isoString)}</div>
      <div style={{ fontSize: '0.85em', color: '#999' }}>
        {formatRelativeTime(isoString)}
      </div>
    </div>
  );
}

export default DateDisplay;

